<template>
  <iModal
    v-model="opened"
    :loading="loading"
    :closable="!loading"
    :mask-closable="!loading"
    width="360"
    @on-visible-change="onVisibleChange"
  >
    <p
      slot="header"
      :class="headerClass"
      class="modal-header">
      <template v-if="kind">
        <iIcon
          :type="iconType"
          style="margin-right: 10px;"/>
        <span
          v-t="i18n('title')"/>
      </template>
    </p>
    <div v-if="kind">
      <p
        v-if="options.count"
        key="options-kind"
      >
        {{ $t(i18n(`message.${options.count > 1 ?
        'other' : 'one'}`), options) }}
      </p>
      <p
        v-else
        key="options-kind"
      >
        {{ $t(i18n('message'), options) }}
      </p>
    </div>
    <div slot="footer">
      <template v-if="kind">
        <iButton
          :disabled="loading"
          size="large"
          @click="cancel">{{ $t(i18n('cancel')) }}</iButton>
        <iButton
          :disabled="loading"
          :type="buttonType"
          size="large"
          @click="confirm">{{ $t(i18n('confirm')) }}</iButton>
      </template>
    </div>
  </iModal>
</template>
<script>
import { get } from 'lodash';

export default {
  name: 'ConfirmationModal',
  data() {
    return {
      opened: false,
      loading: false,
      kind: undefined,
      options: undefined,
    };
  },
  computed: {
    headerClass() {
      const type = get(this.options, 'type');
      return type === 'warning' ? 'warning' : 'info';
    },
    iconType() {
      const type = get(this.options, 'type');
      return type === 'warning' ? 'android-alert' : 'information-circled';
    },
    buttonType() {
      const type = get(this.options, 'type');
      return type === 'warning' ? 'error' : 'success';
    },
  },
  methods: {
    i18n(key) {
      return `modals.${this.kind}.${key}`;
    },
    onVisibleChange(visible) {
      if (!visible) {
        if (this.promise) this.promise.resolve(false);
        // use timeout instead nextTick to allow animation to end
        setTimeout(() => { this.reset(); }, 500);
      }
    },
    open(kind, operation, options) {
      if (this.kind) return; // allow only one modal
      this.kind = kind;
      this.options = options;
      this.operation = operation;
      this.$nextTick(() => { this.opened = true; });
      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        this.promise = { resolve, reject };
      });
    },
    reset() {
      this.loading = false;
      this.promise = undefined;
      this.kind = undefined;
      this.options = undefined;
      this.operation = undefined;
    },
    close() {
      this.opened = false;
    },
    cancel() {
      if (this.loading) return;
      this.close();
    },
    async confirm() {
      if (this.loading) return;
      this.loading = true;
      try {
        const {
          options, i18n, $Message,
        } = this;
        await this.operation();
        const confirmationMsg = options.count ?
          this.$t(i18n(`confirmation_msg.${options.count > 1 ? 'other' : 'one'}`, options)) :
          this.$t(i18n('confirmation_msg'));
        $Message.success(confirmationMsg);
        this.promise.resolve(true);
        this.close();
      } catch (e) {
        this.loading = false;
        throw e;
      }
    },
  },
};
</script>

<style scoped>
 .modal-header {
   text-align: center;
 }
 .modal-header.info {
   color: #19be6b;
 }
 .modal-header.warning {
   color: #ed3f14;
 }
</style>
